import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

const initialState = { ...getInitialState.list() };

export default function (state = { ...initialState }, action) {
    switch (action.type) {
        case actionTypes.LOCATION_ITEM_ADD: {
            return { ...state, item: getInitialState.location() };
        }
        case actionTypes.LOCATION_ITEM_CLEAR: {
            return { ...state, item: null };
        }
        case actionTypes.LOCATION_ITEM_SET: {
            const { location } = action.payload;
            return { ...state, item: location };
        }
        case actionTypes.LOCATION_ITEM_UPDATE: {
            const { location } = action.payload;
            const { item } = state;
            return { ...state, item: { ...item, ...location } };
        }
        case actionTypes.LOCATION_PATCH_SUCCESS: {
            const { location } = action.payload;
            return helpers.getListItemReducer(state, location);
        }
        case actionTypes.LOCATION_PATCH_GEO_SUCCESS: {
            const { location } = action.payload;
            const updatedLocation = helpers.getListItemForId(
                state,
                location.location
            );
            updatedLocation.geo[0].latitude = location.latitude;
            updatedLocation.geo[0].longitude = location.longitude;
            return helpers.getListItemReducer(state, updatedLocation);
        }
        case actionTypes.LOCATIONS_CLEAR:
        case actionTypes.LOCATIONS_GET_REQUEST: {
            return { ...initialState };
        }
        case actionTypes.LOCATIONS_GET_SUCCESS:
        case actionTypes.LOCATIONS_SET: {
            const { locations } = action.payload;
            return helpers.getListReducer(state, locations);
        }
        case actionTypes.LOCATIONS_MERGE:
        case actionTypes.LOCATIONS_POST_SUCCESS: {
            const { locations } = action.payload;
            return helpers.mergeListReducer(state, locations);
        }
        default: {
            return state;
        }
    }
}
